import Cookies from 'js-cookie';

import { getDomain } from './domain';

export const RECENT_ACCOUNTS_COOKIE = 'mlabs-recent-accounts';
export const MAX_RECENT_ACCOUNTS = 3;
const COOKIE_EXPIRES_DAYS = 365;

export function getRecentAccounts() {
  try {
    const raw = Cookies.get(RECENT_ACCOUNTS_COOKIE);
    if (!raw) return [];

    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((account) => account?.email && account?.provider)
      .filter((account, index, list) => {
        const email = account.email.trim().toLowerCase();
        return list.findIndex((item) => item.email.trim().toLowerCase() === email) === index;
      })
      .slice(0, MAX_RECENT_ACCOUNTS);
  } catch {
    return [];
  }
}

export function saveRecentAccount({ name, email, provider }) {
  if (!email || !provider) return getRecentAccounts();

  const account = {
    name: (name || email.split('@')[0] || email).trim(),
    email: email.trim().toLowerCase(),
    provider,
  };

  const others = getRecentAccounts().filter(
    (item) => item.email.trim().toLowerCase() !== account.email,
  );

  const updated = [account, ...others].slice(0, MAX_RECENT_ACCOUNTS);

  Cookies.set(RECENT_ACCOUNTS_COOKIE, JSON.stringify(updated), {
    expires: COOKIE_EXPIRES_DAYS,
    domain: getDomain(),
    sameSite: 'Lax',
  });

  return updated;
}

/**
 * Removes a cookie with the attribute combinations commonly seen in browsers
 * and React Native WebViews (host-only vs Domain, path variants).
 * WKWebView often ignores a single Cookies.remove({ domain }) call.
 */
function removeCookieEverywhere(name) {
  const domain = getDomain();
  const hostname = window.location.hostname;
  const expire = 'Thu, 01 Jan 1970 00:00:00 GMT';

  Cookies.remove(name);
  Cookies.remove(name, { path: '/' });
  if (domain) {
    Cookies.remove(name, { domain, path: '/' });
    Cookies.remove(name, { domain });
  }

  // undefined = host-only cookie (no Domain attribute) — common in WKWebView.
  const domainCandidates = [undefined, hostname, domain].filter(
    (value, index, list) => list.indexOf(value) === index,
  );

  domainCandidates.forEach((cookieDomain) => {
    const domainAttr = cookieDomain ? `; domain=${cookieDomain}` : '';
    document.cookie = `${name}=; expires=${expire}; path=/${domainAttr}`;
    document.cookie = `${name}=; Max-Age=0; path=/${domainAttr}`;
  });
}

export function clearRecentAccounts() {
  removeCookieEverywhere(RECENT_ACCOUNTS_COOKIE);
  return [];
}

export function getAccountInitials(name, email) {
  const source = (name || email || '').trim();
  if (!source) return '?';

  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }

  return source.slice(0, 2).toUpperCase();
}

export function getAvatarColor(email) {
  const palette = ['#7C3AED', '#2563EB', '#0891B2', '#059669', '#D97706', '#DC2626'];
  let hash = 0;
  for (let i = 0; i < email.length; i += 1) {
    hash = email.charCodeAt(i) + hash * 31;
  }
  return palette[Math.abs(hash) % palette.length];
}
